import { render, staticRenderFns } from "./main-page.vue?vue&type=template&id=2555feb4&scoped=true&"
import script from "./main-page.vue?vue&type=script&lang=js&"
export * from "./main-page.vue?vue&type=script&lang=js&"
import style0 from "./main-page.vue?vue&type=style&index=0&id=2555feb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2555feb4",
  null
  
)

export default component.exports